import React, { useEffect, useState } from "react";
import SubNav from "../../../Shared/SubNav";
import { useLocation, useNavigate } from "react-router-dom";
import socket from "../../../context/socket";
import axios from "axios";
import Swal from "sweetalert2";
import api from "../../../utils/api";

const PersonalFinance = () => {
  const location = useLocation();
  const roomId = new URLSearchParams(location.search).get("clientId");
  const navigate = useNavigate();
  const [finalResultData, setFinalResultData] = useState();
  const [loading, setLoading] = useState(true); 
  //  useEffect(() => {
  //   if (roomId) {
  //     setLoading(true);
  //     api
  //       .get(`advisor/personal_finance_ratio_6/${roomId}`)
  //       .then((response) => {
  //         const data = response?.data;
  //          setFinalResultData(data?.final_result);
  //          console.log('data',data.final_result,data);
           
  //         setLoading(false); // ✅ stop loader
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching data:", error);
  //         setLoading(false);
  //       });
  //   }
  // }, [roomId]);

    useEffect(() => {
    api
      .get(
        `advisor/personal_finance_ratio_6/${roomId}`
      )
      .then((response) => {
        const data = response.data;
        setFinalResultData(data.final_result);
        setLoading(false)
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false)
      });
  }, [roomId]);
 
  console.log("finalResultData", finalResultData);

  const reserveSurplus = (
    Number(finalResultData && finalResultData.reserve_to_surplus)
  );
  const savingSurplus = (
    Number(finalResultData && finalResultData.saving_to_surplus)
  );
  const debtIncomeRatio = (
    Number(finalResultData && finalResultData.debt_income_ratio)
  );
  const handleNext = () => {
    const roomId = new URLSearchParams(window.location.search).get("clientId");
    const nextUrl = "/key-action-points?clientId=" + roomId;
    const nextUrl2 = "/key-action-points";

    // console.log("reserveSurplus",reserveSurplus>100,"savingSurplus",savingSurplus>100,"debtIncomeRatio",debtIncomeRatio>100);
    if (
      reserveSurplus > 100 ||
      reserveSurplus < 0 ||
      savingSurplus > 100 ||
      debtIncomeRatio > 100
    ) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Personal Finance Ratios cannot exceed 100%. Please review cash flows before proceeding.",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn  ",
        },
      });
      return;
    }


    socket.emit("navigate", { room: roomId, url: nextUrl2 });
    navigate(nextUrl);
  };

  const handleBack = () => {
    const roomId = new URLSearchParams(window.location.search).get("clientId");
    const prevUrl = "/my-cash-flow?clientId=" + roomId;
    const prevUrl2 = "/my-cash-flow";


    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };

  // const getTextColor = (percentage) => {
  //   return percentage > 75
  //     ? "#87C100"
  //     : percentage > 40
  //       ? "#FFAD33"
  //       : "#FF3300"; // Green, Yellow, Red
  // };


    const getTextColor = (percentage, isDebt = false) => {
    console.log('isDebt',isDebt);
    
  if (isDebt) {
    // ✅ 0–20% = GREEN
    return percentage >= 0 && percentage <= 20
      ? "#87C100"   // green
      : "#FF3300";  // red if high debt
  }

  // existing logic for others
  return percentage > 75
    ? "#87C100"
    : percentage > 40
    ? "#FFAD33"
    : "#FF3300";
};



  const convertDebtFill = (value) => {
  // If value is within 0–20, make it look 90%+ filled
  if (value >= 0 && value <= 20) return 95;
  if (value > 20 && value <= 40) return 70;
  if (value > 40 && value <= 60) return 50;
  if (value > 60 && value <= 80) return 30;
  if (value > 80) return 10;
  return 0;
};
  const RatioCard = ({ title, percentage, description, loading,isDebt }) => (
    <div
      className="ratio-card-wrapper my-3 my-md-0 mx-auto"
      style={{
        borderRadius: "15px",
        padding: "5px",
        background: isDebt
          ? `conic-gradient(
              ${getTextColor(percentage, isDebt)} ${convertDebtFill(percentage)}%, 
              transparent ${convertDebtFill(percentage)}%
            )`
          : `conic-gradient(
              ${getTextColor(percentage)} ${percentage}%, 
              transparent ${percentage}%
            )`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="card"
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "10px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="p-2 p-md-4 text-center">
          {loading ? (
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <>
              <h1
                className="card-title"
                style={{ color: getTextColor(percentage,isDebt) }}
              >
                {percentage?.toFixed(1)}%
              </h1>
              <div className="mt-2 mt-md-4">
                {percentage < 0 && (
                  <p
                    className="text-danger text-center p-0 m-0"
                    style={{ fontSize: "10px" }}
                  >
                    This ratio cannot be calculated accurately as expenses have
                    exceeded income.
                  </p>
                )}
                <h4 className="card-heading">{title}</h4>
                <p className="card-text">{description}</p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="container minht px-4  ">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <h2>Personal Finance Ratios</h2>
          </div>
          <div className="col-lg-4 col-md-12">
            <div className="row">
              <div className="col lh-sm">
                <p className="para">Surplus</p>
                <h5>₹ {finalResultData && Number(finalResultData.monthly_surplus)?.toFixed(0)}</h5>
              </div>
              <div className="col lh-sm">
                <p className="para">Saving</p>
                <h5>₹ {finalResultData && Number(finalResultData.monthly_savings)?.toFixed(0)}</h5>
              </div>
              <div className="col lh-sm">
                <p className="para">EMI</p>
                <h5>₹ {finalResultData && Number(finalResultData.total_emi)?.toFixed(0)}</h5>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="row row-cols-lg-3 row-cols-md-2 row-cols-1 mt-lg-5 mt-1">
          <RatioCard
            title="Reserve Surplus Ratio"
            percentage={reserveSurplus}
            description="Reserve/Surplus Ratio is the proportion of your net income which is in surplus. Any ratio above 25% is considered good with respect to achieving financial goals."
            loading={loading}
          />

          <RatioCard
            title="Saving to Surplus Ratio"
            percentage={savingSurplus}
            description="Proportion of monthly surplus that is being invested on auto mode. Ideally, this should be upwards of 75%."
            loading={loading}
          />

          <RatioCard
            title="Debt to Income Ratio"
            percentage={debtIncomeRatio}
            description="Proportion of monthly net income that is being used towards EMI's. The higher this ratio, the higher the financial burden. Ideally, this should be lower than 20%."
            loading={loading}
          />
        </div> */}

        <div className="row row-cols-lg-3 row-cols-md-2 row-cols-1 mt-lg-5 mt-0">
          <RatioCard
            title="Reserve Surplus Ratio"
            percentage={reserveSurplus}
            // description="Reserve/Surplus Ratio is the proportion of your net income which is in surplus. Any ratio above 25% is considered good with respect to achieving financial goals."
            description="This is the proportion of your net income after all your expenses that is in surplus. It should ideally be above 25%."
            loading={loading}
          />

          <RatioCard
            title="Saving to Surplus Ratio"
            percentage={savingSurplus}
            // description="Proportion of monthly surplus that is being invested on auto mode. Ideally, this should be upwards of 75%."
            description="The part of your surplus that you channel towards productive investing. Ideally, this should be above 75%."
            loading={loading}
          />

          <RatioCard
            title="Debt to Income Ratio"
            percentage={debtIncomeRatio}
            // description="Proportion of monthly net income that is being used towards EMI's. The higher this ratio, the higher the financial burden. Ideally, this should be lower than 20%."
            description="The part of your income that goes towards EMIs. The ideal range is between 0-20%."
            loading={loading}
            isDebt={true}
          />
        </div>

      </div>
      <div className="container  mb-4">
        <div className="row">
          <div className="col text-end">
            <a href="javascript:void(0);" onClick={handleBack}>
              <img
                className="arrow_next1"
                src="assets/images/left-arrowpng.png"
                alt=""
              />
            </a>
            <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
              <img
                className="arrow_next"
                src="assets/images/right-arrow.svg"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>



    </>
  );
};

export default PersonalFinance;
